import React from "react";
import { AccordionDetails } from "@mui/material";
interface Props {
  item: string;
  isActive: boolean;
  onClick: () => void;
}

export const AccordionSimpleItem: React.FC<Props> = ({ item, isActive, onClick }) => {
  return (
    <AccordionDetails
      onClick={onClick}
      sx={{
        cursor: "pointer",
        "&:hover": { background: "#DBE8F5" },
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        ...(isActive && {
          background: "#DBE8F5"
        })
      }}
    >
      {item}
    </AccordionDetails>
  );
};
